import BasicRepository from "./basicRepository";
import Client from "../client";
import FeedResource from "../resources/feedResource";
import { ResourceCollection } from "../resources";
import PackageResource from "../resources/packageResource";

class FeedRepository extends BasicRepository<FeedResource> {
    constructor(client: Client) {
        super("Feeds", client);
    }
    getVersions(feed: FeedResource, packageIds: string[]) {
        return this.client.get(feed.Links["VersionsTemplate"], { packageIds });
    }
    search(feed: FeedResource, searchOptions: {
        packageId?: string,
        partialMatch?: boolean,
        includeMultipleVersions?: boolean,
        includeNotes?: boolean,
        includePreRelease?: boolean,
        versionRange?: string,
        preReleaseTag?: string,
        take?: number,
        descriptionsOptional?: boolean
    }): Promise<PackageResource[]> {
        return this.client.get(feed.Links["SearchTemplate"], searchOptions);
    }
    getNotes(feed: FeedResource, packageId: string, version: any) {
        return this.client.getRaw(feed.Links["NotesTemplate"], { packageId, version });
    }
}

export default FeedRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/feedRepository.ts